const contextualPathTransformer =
	contexts =>
	(path, options = {}) => {
		const {
			preserveSidebarState = false, // unfortunate naming :(
			preserveContexts = preserveSidebarState, // this is better?
			location = window.location
		} = options;

		let transformedPath;
		if (typeof path === 'object') {
			transformedPath = `${path.pathname ? path.pathname : ''}${path.search ? path.search : ''}`;
		} else {
			transformedPath = path;
		}

		const context = contexts.find(({ routesMatcher }) => routesMatcher(transformedPath));
		if (context) {
			return context.queryEncoder(
				{
					location,
					to: transformedPath
				},
				location
			);
		}
		if (!preserveContexts) {
			return transformedPath;
		}

		// re-encode any paths on the current location
		const decodedLocations = contexts
			.map(({ queryDecoder, queryEncoder }) => ({
				decoded: queryDecoder(location),
				queryEncoder
			}))
			.filter(({ decoded }) => decoded);

		if (decodedLocations.length === 0) {
			return transformedPath;
		}
		return contexts
			.map(({ queryDecoder, queryEncoder }) => ({
				decoded: queryDecoder(location),
				queryEncoder
			}))
			.filter(({ decoded }) => decoded)
			.reduce(
				(to, { decoded, queryEncoder }) =>
					queryEncoder(
						{
							location: {
								pathname: typeof to === 'object' ? to.pathname : to
							},
							to:
								typeof to === 'object'
									? {
											...to,
											pathname: decoded.pathname,
											search: decoded.search
										}
									: `${decoded.pathname}${decoded.search}`
						},
						location
					),
				transformedPath
			);
	};

export default contextualPathTransformer;
